export default __webpack_public_path__ + "static/media/fire-filled.1e2aae94.svg";